import React from 'react';
import { FadeInUp, SlideInLeft, SectionLabel, AccentLine, ParallaxImage } from './AnimationWrappers';

const AboutSection = () => {
  return (
    <section id="about" data-testid="about-section" className="relative overflow-hidden" style={{ background: '#FAF8F5', padding: '50px 0 40px' }}>
      <div className="container-main">
        <SlideInLeft>
          <SectionLabel number="01" title="About" />
        </SlideInLeft>
        <FadeInUp>
          <AccentLine />
        </FadeInUp>

        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] items-start" style={{ gap: '50px' }}>
          {/* Text */}
          <div>
            <FadeInUp>
              <h2 className="font-display mb-5" style={{
                fontSize: '2.4rem', fontWeight: 700, lineHeight: 1.1, letterSpacing: '-0.02em', color: '#1C1C1E'
              }}>
                Not a factory.
                <br />
                A manufacturing <span style={{ color: '#C8102E' }}>laboratory.</span>
              </h2>
            </FadeInUp>
            <FadeInUp delay={0.1}>
              <p className="font-body mb-5" style={{ fontSize: '0.95rem', color: '#3A3A3C', lineHeight: 1.75 }}>
                Founded in 1994, Qualiance International Limited operates at the intersection of textile science and industrial engineering. We don't see garments as products — we see them as engineering challenges that demand precision, repeatability, and zero-defect execution.
              </p>
            </FadeInUp>
            <FadeInUp delay={0.2}>
              <p className="font-body mb-8" style={{ fontSize: '0.95rem', color: '#3A3A3C', lineHeight: 1.75 }}>
                With our corporate headquarters in Mumbai and our purpose-built manufacturing facility in Tiruppur, Tamil Nadu, we have spent more than three decades perfecting the art of technical garment construction — from Swiss military combat systems to performance outerwear for global brands.
              </p>
            </FadeInUp>

            {/* Stat grid - 2x2 with red top borders */}
            <FadeInUp delay={0.3}>
              <div className="grid grid-cols-2 gap-x-10 gap-y-8">
                {[
                  { num: '1994', label: 'Established' },
                  { num: '25+', label: 'Years Supplying Swiss Government' },
                  { num: 'Mumbai', label: 'Corporate Office' },
                  { num: 'Tiruppur', label: 'Manufacturing Facility' },
                ].map((s, i) => (
                  <div key={i} style={{ borderTop: '3px solid #C8102E', paddingTop: '16px' }}>
                    <span className="font-display block" style={{ fontSize: '2.2rem', fontWeight: 700, color: '#1C1C1E', lineHeight: 1.1 }}>{s.num}</span>
                    <span className="font-mono block mt-2" style={{ fontSize: '0.67rem', color: '#6B6B6F', textTransform: 'uppercase', letterSpacing: '0.12em', lineHeight: 1.5 }}>{s.label}</span>
                  </div>
                ))}
              </div>
            </FadeInUp>
          </div>

          {/* Image */}
          <FadeInUp delay={0.15}>
            <ParallaxImage
              src="/qualiance-building.png"
              alt="Qualiance International Limited manufacturing facility, Tiruppur"
              className="aspect-[4/3] lg:aspect-[1/1]"
            />
          </FadeInUp>
        </div>
      </div>
      <div className="section-number">01</div>
    </section>
  );
};

export default AboutSection;
